import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This timeless garden design was inspired by the classic architecture of a family home built in the 50’s. This gentle and inviting garden takes its structure from simple circular built elements. The sandstone flagging and ballast walls provide the strong architectural elements which is complemented by the decomposed granite seating area.',
            'The round geometric pattern in the breeze block wall again reflects the circular design and respects the era in which the home was built.',
            'While the subtle raised lawn area creates interest it also provides an effective solution to dealing with the exposed bedrock from what was an abandoned quarry.',
            'The simple layers of green and soft grey plantings with lawn further add to the composition, softening the hard surfaces. The garden design provides a sophisticated and complementary extension to the living areas of the home.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Design
          <br />Construction
          <br />Ongoing Maintenance
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          </p>
        ),
        image : '../images/projects/cheltenham-2.jpg',
        title : 'Cheltenham'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/cheltenham-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/cheltenham-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/cheltenham-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/cheltenham-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/cheltenham-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/cheltenham-6.jpg'
    },
]

const PageCheltnhem = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageCheltnhem